module.exports = __webpack_public_path__ + "static/img/10.0c097b92.jpg";